import React, { useState } from "react";

interface NewClientFormStepProps {
  phone: string;
  onSubmit: (name: string) => void;
  onBack: () => void;
  isLoading: boolean;
}

export const NewClientFormStep: React.FC<NewClientFormStepProps> = ({
  phone,
  onSubmit,
  onBack,
  isLoading,
}) => {
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || name.trim().length < 3) {
      setError("Por favor ingresa tu nombre completo.");
      return;
    }
    setError(null);
    onSubmit(name.trim());
  };

  return (
    <form id="new-client-form-step" onSubmit={handleSubmit} className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-bold text-gray-900">Completa tu Registro</h2>
        <p className="text-sm text-gray-600">
          No encontramos un registro previo con el número <span className="font-semibold text-gray-800">{phone}</span>. Por favor ingresa tu nombre para continuar.
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="new-client-name-input" className="block text-sm font-medium text-gray-700 mb-1">
            Nombre y Apellido
          </label>
          <input
            id="new-client-name-input"
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError(null);
            }}
            placeholder="Ej. Juan Pérez"
            disabled={isLoading}
            className="block w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 focus:ring-blue-600 focus:border-blue-600 text-base transition duration-150 disabled:bg-gray-100"
            autoFocus
            required
          />
          {error && <p className="mt-2 text-xs text-red-600">{error}</p>}
        </div>

        <div>
          <label htmlFor="new-client-phone-display" className="block text-sm font-medium text-gray-700 mb-1">
            Teléfono Móvil
          </label>
          <input
            id="new-client-phone-display"
            type="text"
            value={phone}
            disabled
            className="block w-full px-4 py-3 bg-gray-100 border border-gray-300 rounded-lg text-gray-600 text-base cursor-not-allowed"
          />
        </div>
      </div>

      <div className="space-y-3">
        <button
          id="create-client-submit-btn"
          type="submit"
          disabled={isLoading}
          className="w-full flex items-center justify-center py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 disabled:opacity-50"
        >
          {isLoading ? (
            <span className="flex items-center space-x-2">
              <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              <span>Registrando datos...</span>
            </span>
          ) : (
            "Registrar e Ingresar"
          )}
        </button>

        <button
          id="create-client-back-btn"
          type="button"
          disabled={isLoading}
          onClick={onBack}
          className="w-full flex items-center justify-center py-3 px-4 border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 transition duration-150 disabled:opacity-50"
        >
          Volver a ingresar teléfono
        </button>
      </div>
    </form>
  );
};
